import React from 'react';

import { ButtonIcon } from '@pkg/components/Sections/Profile/Buttons';

import { type MainNavigationItemProps } from './types';

import { MainNavigationItemLabel, MainNavigationItemLabelWrapper, MainNavigationItemWrapper } from './styles';

const variants = {
    inactive: {
        opacity: 0,
        scale: 0.5,
        y: 4,
    },
    active: {
        opacity: 1,
        scale: 1,
        y: 0,
    },
};

export const MainNavigationItem = ({ children, item, isActive, label, onClick }: MainNavigationItemProps) => {
    return (
        <MainNavigationItemWrapper initial="inactive" whileHover="active">
            <MainNavigationItemLabelWrapper>
                <MainNavigationItemLabel variants={variants}>{label}</MainNavigationItemLabel>
            </MainNavigationItemLabelWrapper>
            <ButtonIcon onClick={() => onClick(item)} color={isActive ? 'gradient' : 'transparent'} size="smallMedium">
                {children}
            </ButtonIcon>
        </MainNavigationItemWrapper>
    );
};
